exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// C:/Users/martin.marada/Documents/frontend/node_modules/core-js/library/modules/_object-pie.js
// module id = 22
// module chunks = 0